export interface ChartDataLike {
    datasets?: ReadonlyArray<{ data?: ReadonlyArray<unknown> }>;
}

/**
 * Whether any dataset holds a plottable value: a finite number, an `{x, y}` point with a
 * finite `y`, or any other non-null point (a `[start, end]` floating bar). `0` is a value;
 * `null`, `undefined` and `NaN` are gaps.
 *
 * The one definition of "no data" for every chart. `MetricChart` uses it to swap in its
 * `noDataMessage`, and the chart wrappers' no-data plugin uses it for everything else.
 */
export function hasPlottableValue(data: ChartDataLike): boolean {
    return (data.datasets ?? []).some((dataset) =>
        (dataset.data ?? []).some((point) => {
            if (point === null || point === undefined) return false;
            if (typeof point === 'number') return Number.isFinite(point);
            if (typeof point === 'object' && 'y' in point) {
                const { y } = point;
                return typeof y === 'number' && Number.isFinite(y);
            }
            return true;
        })
    );
}
